<template>
    <a-drawer
        :title="options.title"
        placement="bottom"
        :visible="visible"
        height="65%"
        :destroyOnClose="true"
        @close="visible = false"
    >
        <div class="options-group" v-for="(group, index) in options.options" :key="index">
            <div :style="{width: 100/options.itemCount + '%'}" class="group-item" v-for="(item, i) in group" :key="index + '_' +  i + item.label">
                <div v-if="item.value" class="item-value" @click="handleItem(item)"
                     :class="item.isActive ? 'item-value-active' : ''">{{item.label}}</div>
                <div v-else class="item-label">{{item.label}}</div>
            </div>
        </div>
    </a-drawer>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            visible: false,
            options: {
                key: '',
                title: '标题',
                placement: 'bottom',
                value: '',
                itemCount: 3,
            }
        }
    },
    methods: {
        init(options = {}) {
            this.visible = true
            Object.assign(this.options, options)
            if (this.options.options && this.options.options.length > 0) {
                this.options.options.forEach((group) => {
                    group.forEach(item => {
                        item['isActive'] = item.value == this.options.value
                    })
                })
            }
        },
        handleItem(item) {
            this.visible = false
            this.$emit('select', this.options.key, item)
        }
    }
}
</script>

<style lang="less" scoped>
.options-group {
    display: flex;
    flex-wrap: wrap;
    .group-item {
        width: 33.33%;
        padding: 5px;
        box-sizing: border-box;
        cursor: pointer;
        .item-value {
            background: #fff;
            height: 50px;
            line-height: 50px;
            border-radius: 2px;
            text-align: center;
            font-size: 16px;
            transition: all .3s;
        }
        .item-label {
            height: 50px;
            line-height: 50px;
            color: #7c7c7d;
            text-align: left;
            font-size: 15px;
            padding-left: 5px;
        }
        .item-value-active {
            background: #3eb475;
            color: #fff;
        }
    }
    .group-item:hover {
        .item-value {
            background: #3eb475;
            color: #fff;
        }
    }
}

/deep/ .ant-drawer-wrapper-body {
    background: #f8f8f9;
    overflow: hidden;
    >div {
        background: #f8f8f9;
    }
    .ant-drawer-body {
        padding: 15px 15px 150px 15px;
        height: 100%;
        overflow-y: auto;
    }
    .ant-drawer-title {
        text-align: center;
        color: #565657;
    }
    .ant-drawer-close {
        left: 0;
    }
}

</style>
